import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RouteBean } from '../model/RouteBean';
import { RouterService } from '../services/router.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { Role } from 'src/userRoles/userRoles';
import { UserroleService } from './../../utility/userrole.service';
import { error } from 'console';
import * as moment from 'moment-timezone';

export const defaultDateFormatToDisplay: string = 'yyyy-MM-ddTHH:mm:ss.SSSZ';

@Component({
  selector: 'app-edit-route-form',
  templateUrl: './edit-route-form.component.html',
  styleUrls: ['./edit-route-form.component.css']
})
export class EditRouteFormComponent {
  @Input() particularRow: RouteBean;
  dateArray: any[];
  @Output() submitClickedEvent = new EventEmitter<boolean>();
  @Output() cancelClickEvent = new EventEmitter<boolean>();
  isActive: boolean;
  periodArray: any;

  constructor( private confirmationService: ConfirmationService, private messageService: MessageService, private routerService: RouterService,
    private authenticationService: AuthenticationService, private userRoleservice: UserroleService 
  ){}

  ngOnChanges() { 
    let data1: any[] = [];
    if(this.particularRow) {
      this.particularRow.periods.forEach(x =>{
        if(x.validFrom) {
          x.validFrom = new Date(x.validFrom);
        }
        if(x.validTo) {
          x.validTo = new Date(x.validTo);
        } 
        data1.push(x);
      })
      this.dateArray = data1;
      this.routerService.dateArray = this.dateArray;
      this.isActive = this.particularRow.isActive
    }
  }

  deleteClicked(index: number) {
    this.dateArray.splice(index, 1);
    this.routerService.dateArray = this.dateArray;
  }

  isEditable() {
    if(this.authenticationService.canUserEdit()) {
      return this.particularRow.canEdit;
    } else {
      return false;
    }
  }

  addNewBound() {
    if(this.dateArray.length > 0 && this.dateArray[(this.dateArray.length-1)].validTo) {
      let z = this.dateArray[(this.dateArray.length-1)].validTo;
      let x = new Date(z);
      x.setDate(z.getDate() + 1);
      
      this.dateArray.push({
        validFrom: x
      })
    } else {
      this.dateArray.push({})
    }
    this.routerService.dateArray = this.dateArray;
  }

  submitClicked() {
    let user = this.authenticationService.getCurrentUser();
    let cvr = user?.cvr;
    let receipientAuthorityCvr = this.particularRow.key.recipientAuthority.cvr;
    let userRole = this.authenticationService.getAppRole();
    let isValid = this.userRoleservice.isAdmin(userRole);
    if(cvr != receipientAuthorityCvr && (isValid != Role.Kombit_administrator))
    {
      this.confirmationService.confirm({
        message:
          'Bemærk, at du opdaterer delegeret rute...',
        header: 'Advarsel',
        rejectLabel: 'Ja',
        acceptLabel: 'Nej',
        reject: () => {
          this.update();
        },
      });
    }
    else {
      this.update();
    }
  }

  update() {
    let periodsForSending: any[] = [];
    this.dateArray.forEach((dval)=>{
      let valFromStr: string | null = null;
      let valToStr: string | null = null;
      if (dval.validFrom) {
        valFromStr = moment(dval.validFrom).format('YYYY-MM-DD');
      }
      if (dval.validTo) {
        valToStr = moment(dval.validTo).format('YYYY-MM-DD');
      }
      periodsForSending.push({
        validFrom: valFromStr,
        validTo: valToStr,
		periodUuid: dval.periodUuid
      });
    });

    this.routerService.updateRouter(periodsForSending, this.isActive, this.particularRow.uuid).
    then(data => {
        this.submitClickedEvent.emit(true);
      }, error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.errorMessage,
          life: 3000,
        });
      }
    );
  }
  
  cancelClick() {
    if(this.isActive != this.particularRow.isActive || 
      JSON.stringify(this.dateArray) !== JSON.stringify(this.particularRow.periods))
    {
      this.confirmationService.confirm({
        message:
          'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
        header: 'Ændringer er ikke gemt',
        rejectLabel: 'Nej',
        acceptLabel: 'Ja',

        accept: () => {
          this.routerService.dateArray = undefined;
          this.cancelClickEvent.emit(true);
        },
      });
    } else {
      this.cancelClickEvent.emit(true);
    }
  }

  onStatusChange() {
    this.routerService.isActive = this.isActive;
  }
}

